import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteFacilityProvider } from 'api/Admin/Practice/Providers';

import { useTableContext } from 'lib/context/TableContext/TableContext';

import { showAlert } from 'components/shared/Alert/Alert';
import { withErrorBoundary } from 'components/shared/Error/Boundary';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Popover from 'components/shared/Popovers/Popover/Popover';

const Actions = ({ data }) => {
  const [deleteModal, setDeleteModal] = useState(null);
  const { setSelectedItem, setShowModal } = useTableContext();

  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const mutateDeleteFacilityProvider = useMutation({
    mutationFn: () => deleteFacilityProvider(navigate, { id: data?.id }),
    onSuccess: () => {
      queryClient.invalidateQueries(['facility-provider']);
      showAlert({ title: `${name} deleted successfully`, color: 'success' });
    }
  });

  const actionOptions = [
    {
      label: 'Delete',
      icon: 'trash-mono',
      onClick: () => {
        setDeleteModal(true);
      }
    },
    {
      label: 'Edit',
      icon: 'edit-2-mono',
      onClick: () => {
        setSelectedItem(data);
        setShowModal(true);
      }
    }
  ];

  return (
    <>
      <Popover
        isFixed
        position="left"
        isBorder={false}
        options={actionOptions}
        className="flex h-full items-center"
      />
      {!!deleteModal && (
        <Confirm
          isOpen={deleteModal}
          title={`Delete Facility Provider ${data?.id}`}
          message="Are you sure you want to delete this facility provider?"
          variant="danger"
          icon="trash-mono"
          handleClose={() => setDeleteModal(false)}
          footerActions={{
            primary: {
              text: 'Delete',
              onClick: () => mutateDeleteFacilityProvider.mutate(),
              color: 'danger',
              isLoading: mutateDeleteFacilityProvider.isLoading
            }
          }}
        />
      )}
    </>
  );
};

export default withErrorBoundary(Actions);
